import React, { useContext, useState } from 'react';
import AntButton, { ButtonProps as AntButtonProps } from 'antd/lib/button';
import useComponentConfiguration from 'DisplayFramework/useComponentConfiguration';
import { Input, notification } from 'antd';
import { useDisplayFrameworkContext } from 'DisplayFramework/hooks/useDisplayFrameworkContext';
import { SaveOutlined } from '@ant-design/icons';
import { ParPagComponentRequest, updatePageComponent } from 'services/displayFramework';
import { AuthContext } from 'components/Auth/Auth';
import RouterLink from 'components/RouterLink';

export type ButtonProps = Omit<AntButtonProps, 'children'> & {
  to?: string;
  comcode: string;
  custom?: any;
  Inspectstyle?: React.CSSProperties;
  onlyIcon?: boolean;
  icon?: React.ReactNode; 
};

const ResetButtonAction = ({ comcode, custom, Inspectstyle, onlyIcon, icon, className, ...otherProps }: ButtonProps) => {
  const { isInspect } = useContext(AuthContext);
  const { isHidden, label, style } = useComponentConfiguration(comcode);
  const { pagcode, refresh } = useDisplayFrameworkContext();
  const [newLabel, setNewLabel] = useState('');

  if (isHidden) {
    return null;
  }

  const handleSaveNewLabel = (comcode: string, labelp: string) => {
    const request: ParPagComponentRequest = {
      comcode: comcode ?? '',
      comformat: '',
      comhint: '',
      comlabel: newLabel === '' ? label : labelp,
      commessage: '',
      complaceholder: '',
      comrequired: false,
      comstyle: '',
      comtype: '',
      pagcode: pagcode ?? '',
    };
    updatePageComponent({ request }).then((res) => {
      if (res.code === '200') {
        notification.success({
          message: res.message,
          description: res.description,
        });
      } else {
        notification.error({
          message: res.message,
          description: res.description,
        });
      }
      refresh();
    });
  };

  const props = {
    ...otherProps,
    children: isInspect ? (
      <Input
        defaultValue={label === '' ? comcode : label}
        size="middle"
        onChange={(event) => {
          event.preventDefault();
          setNewLabel(event.target.value);
        }}
        onClick={(event) => {
          event.preventDefault();
        }}
        style={Inspectstyle ?? { width: '80%' }}
        className="input-inspect"
        addonAfter={
          <SaveOutlined
            onClick={(ev) => {
              ev.preventDefault();
              handleSaveNewLabel(comcode, newLabel);
            }}
          />
        }
      />
    ) : onlyIcon ? '' : label,
    style,
  };

  if (props.to) {
    return <RouterLink component={AntButton} {...props} />;
  } else {
    return (
      <AntButton
        htmlType="reset"
        {...props}
        icon={icon}
        className={`ut-reset-btn ${className}`}
      />
    );
  }
};

export default ResetButtonAction;
